import { WSPage, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { useBrowserPageTitle } from "../../../components/BrowserPageTitle/BrowserPageTitle";
import { FilterableTablePayables } from "../../../modules/Payables/components/TablePayables/FilterableTablePayables";
import {
  PATH_PAYABLES,
  PATH_PAYABLES_DISPUTED
} from "../../../modules/Payables/paths";

export const PayablesDisputed: React.FC = () => {
  const history = useHistory();
  useBrowserPageTitle("Disputed Payables");

  return (
    <WSPage
      title="Disputed Payables"
      breadcrumb={{
        label: "Payables",
        icon: "arrow-left",
        onClick: () => history.push(PATH_PAYABLES)
      }}
    >
      <WSText.ParagraphSm color="gray500" mb="XL">
        Contractor(s) have disputed these invoices. Review their reason in "All
        Activity", then approve, edit, or cancel the invoice. As the payer, you
        have final approval.
      </WSText.ParagraphSm>
      <FilterableTablePayables
        tab="disputed"
        detailsBasePath={PATH_PAYABLES_DISPUTED}
        visibleColumns={{
          payee: true,
          payableNumber: true,
          amount: true,
          openedAt: true,
          status: true
        }}
        visibleFilters={{
          payeeId: true,
          openedDateRange: true
        }}
        emptyState={{
          standart: "No unsent payables."
        }}
      />
    </WSPage>
  );
};
